import { Skeleton } from '@mui/material'
import React from 'react'

interface IProps {
  children: JSX.Element
  loadData: {
    width?: number
    height?: number
    loading: boolean
    className?: string
  }
}
const SkeletonComp = (props: IProps): JSX.Element => {
  return props.loadData.loading ? (
    <Skeleton className={props.loadData.className || ''} width={props.loadData.width} height={props.loadData.height} />
  ) : (
    props.children
  )
}

export default SkeletonComp
